export default __webpack_public_path__ + "static/media/cloud-ball.362e5cdb.png";